export default function Logo({ className = "", variant = "dark" }) {
    // variant: "dark" (for light bg) | "light" (for dark bg)
    const navy = variant === "light" ? "#FFFFFF" : "#0B1437";
    const gold = "#C9A959";
    return (
        <span className={`inline-flex items-baseline gap-2 ${className}`}>
            <svg width="34" height="34" viewBox="0 0 64 64" className="shrink-0">
                {/* Shield w/ crown ticks */}
                <path
                    d="M16 22 L32 16 L48 22 L48 36 C48 44 41 50 32 52 C23 50 16 44 16 36 Z"
                    fill="none"
                    stroke={gold}
                    strokeWidth="2"
                />
                {/* Crown ticks */}
                <path d="M20 22 L20 16 L24 20 L28 14 L32 18 L36 14 L40 20 L44 16 L44 22" fill="none" stroke={gold} strokeWidth="1.5" strokeLinejoin="round" />
                {/* Center diamond */}
                <path d="M32 30 L35 34 L32 42 L29 34 Z" fill={gold} />
                {/* Inner L serif */}
                <text
                    x="32"
                    y="48"
                    fontFamily="'Cormorant Garamond', Georgia, serif"
                    fontSize="11"
                    fontWeight="700"
                    fill={gold}
                    textAnchor="middle"
                    fontStyle="italic"
                    letterSpacing="0.1em"
                >
                    LK
                </text>
            </svg>
            <span
                className="font-serif font-semibold tracking-tight leading-none text-[26px] md:text-[30px]"
                style={{ color: navy }}
            >
                Loylty<span className="italic" style={{ color: gold }}>Kart</span>
            </span>
        </span>
    );
}
